export function errMsg(errObj) {
  return Object.keys(errObj).reduce(function(str, fieldName) {
    return str + fieldName + " : " + errObj[fieldName] + "\n";
  }, "");  
}

export function errMsgList(errObj) {
  return Object.keys(errObj).map(function(fieldName) {
    return {
      field_name: fieldName, 
      errors: errObj[fieldName]
    }
  })
}